import React from 'react';
import { Table } from 'antd';

const columns = [{
	title: 'Compression Level',
	dataIndex: 'mode',
}, {
	title: 'jpg',
	children: [{
		title: 'mozjpeg',
		dataIndex: 'mozjpeg',
		align: 'center'
	}
	]
}, {
	title: 'png',
	children: [{
		title: 'pngquant',
		dataIndex: 'pngquant',
		align: 'center'
	}, {
		title: 'ect',
		dataIndex: 'ect',
		align: 'center'
	}
	] }
];

const data = [{
	key: '1',
	mode: 'Normal',
	mozjpeg: 'Q 85',
	pngquant: 'Q 85-100, S 3',
	ect: '5',
}, {
	key: '2',
	mode: 'Good',
	mozjpeg: 'Q 80',
	pngquant: 'Q 0 - 100 (Auto), S 1',
	ect: '5',
}, {
	key: '3',
	mode: 'High',
	mozjpeg: 'Q 70',
	pngquant: 'Q 70-85, S 1',
	ect: '9',
}, {
	key: '4',
	mode: 'Extreme',
	mozjpeg: 'Q 60',
	pngquant: 'Q 60-70, S 1',
	ect: '9',
}];

const CompressionTable = () => {
	return (
		<div>
			<Table
				dataSource={data}
				columns={columns}
				size="small"
				bordered
				pagination={false}
				title={() => { return 'Q = Quality, S = Speed. Lower Quality = Higher compression'; }}
			/>
		</div>
	);
};

export default CompressionTable;



// WEBPACK FOOTER //
// ./src/components/CompressionTable.js